import { actionTypes as itemActionTypes } from "../../../items/actions";
import rootActionTypes from "../../../rootActionTypes";
import { getAffectedActionIds } from "./getIdsFromActions";

const individualActionTypes = [
  //#!if readonly !== true
// itemActionTypes.SET_IMAGE,
// itemActionTypes.CLEAR_IMAGE
  //#!endif
];

const globalActionTypes = [rootActionTypes.LOAD_FILE, rootActionTypes.UPDATE_FILE, rootActionTypes.LOAD_SAMPLE];

export const getImagePathForItem = (item, attachmentsById) => {
  const a = item.image ? attachmentsById.get(item.image) : null;
  return a ? a.path : null;
};

// Changes:
//   - imagePath
const applyImagePathUpdates = (state, action, newItemsById, newAttachmentsById) => {
  const { affectedIds } = getAffectedActionIds(state, action, globalActionTypes, individualActionTypes);

  if (affectedIds.length === 0) {
    return state;
  }

  return state.withMutations(s => {
    affectedIds.forEach(cId => {
      const imagePath = getImagePathForItem(newItemsById.get(cId), newAttachmentsById);
      const itemRec = state.get(cId);
      if (imagePath !== itemRec.imagePath) {
        s.update(cId, d => d.set("imagePath", imagePath));
      }
    });
  });
};

export default applyImagePathUpdates;
